import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  @Input() public title: string;
  @Input() public message: string;
  @Input() public showInfo = true;
  @Input() public buttonText: String = 'Ja, löschen';
  @Input() public requireConfirmation = false;
  @Input() public confirmationLabel: string = '';
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  public confirmed = false;

  constructor(public modal: NgbActiveModal, public translate: TranslateService) {}

  ngOnInit() {}
}
